<style>
    .m-error-2 .m-error_container .m-error_title2 > h1 {
        margin-top: 0;
        padding-top: 20%;
    }

    .recze_404 {
        padding-bottom: 55%;
    }
</style>

<template>
    <div class="m-grid__item m-grid__item--fluid m-grid m-error-2 recze_404"
         style="background-image: url(../../../static/app/media/img/error/bg2.jpg);">
        <div class="m-error_container">
                    <span class="m-error_title2 m--font-light">
                        <h1>
                            {{$t('OOPS!')}}
                        </h1>
                    </span>
            <span class="m-error_desc m--font-light">
                        {{$t('Something went wrong here')}}
                    </span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'NotFound',
  created: function () {
    this.$emit('updateDisable', true)
    this.$emit('updateTitle', this.$translate.t('Page not found'))
    this.$store.commit('loading/change', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/NotFound.vue